import React from "react";

/* eslint-disable max-len */
export default function UploadSlideIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <defs>
                <clipPath id="a">
                    <path
                        data-name="\u9577\u65B9\u5F62 1719"
                        fill="#9c9c9c"
                        d="M0 0H29.6V21.954H0z"
                    />
                </clipPath>
            </defs>
            <g data-name="\u30B0\u30EB\u30FC\u30D7 557">
                <g data-name="\u30B0\u30EB\u30FC\u30D7 549">
                    <g
                        data-name="\u30B0\u30EB\u30FC\u30D7 548"
                        clipPath="url(#a)"
                        fill="#9c9c9c"
                        transform="translate(-40 -155) translate(40.2 159)"
                    >
                        <path
                            data-name="\u30D1\u30B9 8166"
                            d="M25.95 21.979v-4.538a1.007 1.007 0 011.007-1.006h2.688l-6.61-7.618-6.61 7.618h2.688a1.007 1.007 0 011.007 1.006v4.538z"
                            transform="translate(-.046 -.025)"
                        />
                        <path
                            data-name="\u30D1\u30B9 8167"
                            d="M20.551 0H1.875A1.921 1.921 0 000 1.969v12.802a1.92 1.92 0 001.945 1.9h11.543L22.23 6.6a.911.911 0 01.266-.19V1.969v-.072A1.92 1.92 0 0020.551 0m-8.708 12.385H4.421a.556.556 0 110-1.1h7.422a.556.556 0 110 1.1m3.167-3.5H4.336a.549.549 0 110-1.1H15.01a.549.549 0 110 1.1m3.022-3.5H4.314a.549.549 0 010-1.1h13.717a.549.549 0 010 1.1"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
